import { Button } from 'atoms/Button';
import { Body, Title } from 'atoms/Typography/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useRouter } from 'modules/next/hooks';
import { AppRoutes } from 'modules/shop/routes';
import { useLogout } from 'modules/shop/user/hooks';
import styles from './styles.module.css';

export const AccountView = () => {
  const t = useTranslations();
  const router = useRouter();
  const { handleLogout } = useLogout();

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <Title type="md" tag="h2">
          {t('login.popup.auth-title')}
        </Title>
        <Body type="sm">{t('login.popup.auth-subtitle')}</Body>
        <Button
          color="deep-purple"
          onClick={() => router.push(AppRoutes.ACCOUNT)}
        >
          {t('login.popup.auth-button')}
        </Button>
      </div>
      <div className={styles.bottom}>
        <Button className={styles.buttonLink} onClick={handleLogout}>
          {t('common.buttons.exit')}
        </Button>
      </div>
    </div>
  );
};
